// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content[data-v-a3ded858] {\n  border: 0px solid red;\n}\n", ""]);
// Exports
module.exports = exports;
